import { Button } from '@/shared/ui/primitives'

export type ErrorBoundaryFallbackProps = {
  onReload: () => void
}

export function ErrorBoundaryFallback({ onReload }: ErrorBoundaryFallbackProps) {
  return (
    <div className="flex h-full min-h-[60vh] flex-col items-center justify-center gap-3 p-6 text-center">
      <h1 className="text-xl font-semibold">Something went wrong</h1>
      <p className="text-sm text-muted-foreground">
        An unexpected error occurred. Please reload the page to continue.
      </p>
      <Button type="button" onClick={onReload}>
        Reload
      </Button>
    </div>
  )
}
